import { render } from "./UmbrellaIcon.vue?vue&type=template&id=4578ad22"
import script from "./UmbrellaIcon.vue?vue&type=script&lang=js"
export * from "./UmbrellaIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__